import { LegalPage } from '../components/LegalPage';

/**
 * Community Guidelines page. Reaches users coming in from a Report
 * modal, the Safety Center, or curiosity. Should be short, plain, and
 * positive — describes what kindness looks like in this space, not
 * just a list of rules.
 */
export function Guidelines() {
  return (
    <LegalPage title="Community Guidelines" lastUpdated="2026-05-23">
      <p>
        LessAlone works because the people using it choose to be kind to a stranger. These
        guidelines describe what that looks like in practice.
      </p>

      <h2>Be a person another person would want to talk to</h2>
      <ul>
        <li>Open with warmth, not a sales pitch.</li>
        <li>Ask what they're up to. Notice what they say back.</li>
        <li>
          It's fine to be tired, fine to be quiet, fine to not have anything interesting to share.
          The point is the company, not the performance.
        </li>
      </ul>

      <h2>Keep it in the app</h2>
      <ul>
        <li>
          Don't ask for or share contact info — no phone, no Instagram, no WhatsApp, no email.
        </li>
        <li>Don't try to meet in person. LessAlone is text-based on purpose.</li>
        <li>If someone pressures you to move off the app, that's a signal — use Report.</li>
      </ul>

      <h2>What's not allowed</h2>
      <ul>
        <li>Harassment, threats, slurs, or messages meant to flame or destabilize someone.</li>
        <li>Sexual content, even if framed playfully.</li>
        <li>
          Anything that suggests the other person may be under 18 — Report immediately, do not try
          to engage.
        </li>
        <li>Asking for money, gifts, donations, or financial information.</li>
        <li>Selling, promoting, or recruiting for anything.</li>
        <li>
          Sharing another member's real identity, photo, or anything they didn't share with you in
          the app.
        </li>
      </ul>

      <h2>Crisis</h2>
      <p>
        If you sense your peer is in immediate danger, gently surface 988 (call or text) and Crisis
        Text Line (text HOME to 741741). You are not their counselor and you are not responsible for
        fixing it — but pointing them at help is always welcome.
      </p>

      <h2>How we respond to a Report</h2>
      <p>
        A real human moderator reviews every report. Depending on what they find: nothing happens, a
        warning is sent, the conversation is ended, or — for the most serious violations — the
        account is banned. Your peer never knows you reported them.
      </p>

      <h2>How to get unbanned</h2>
      <p>
        If you believe an action was a mistake, reply to the email you received with one or two
        sentences explaining the context. A moderator will review.
      </p>
    </LegalPage>
  );
}
